<template>
    <h4 v-if="!this.isLoading" :style="{
      fontSize: size + 'px',
      display: 'flex',
      alignItems: 'center',
      gap: '5px',
      cursor: 'pointer',
      margin: 0,
      color: color
    }" @click="reload">
        <b-img v-if="useIcon" :src="require('@/assets/images/ic_wallet.png')" :width="size * 1.5" rounded="circle" alt="Circle image"></b-img>
        <span>{{ user.balance ? user.balance.toLocaleString() : 0 }} VNĐ</span>
        <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-refresh-cw"><path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M8 16H3v5"/></svg>
    </h4>
    <h4 v-else :style="{
      fontSize: size + 'px',
      margin: 0,
      color: color
    }">Đang cập nhật ...</h4>
</template>
  
<script>
import { mapState, mapActions } from 'vuex'

export default {
  props: ['size', 'color', 'useIcon'],
  data() {
    return {
        isLoading: false
    }
  },
  computed: {
    ...mapState('auth', ['user'])
  },
  methods: {
    ...mapActions("auth", ["authInfo"]),

    reload() {
        if (this.isLoading) return;
        this.isLoading = true;
        this.authInfo().then(() => {
            this.isLoading = false;
        })
    }
  }
}
</script>